<lib-picklist-modal #pickListModal (pickListValues)="emitPickListValues($event)"></lib-picklist-modal>
<div class="attribute-table" *ngFor="let table of chat.attributeTables; let i = index">
  <h2>{{ table.tableName }}</h2>
  <p class="text-style-3">{{ table.tableDescription }}</p>
  <ul>
    <li class="attribute-field" *ngFor="let field of table.attributeFields">
      <span class="text-style-2 field-title">{{ field.fieldTitle }}</span>
      <span class="text-style-5 field-name">{{ table.tableName }}.{{ field.fieldName }}</span>
      <button class="picklist-button" *ngIf="field.picklistId" type="button" coreUIButton="icon"
              (click)="showPicklist(field.picklistId, table.tableName + '.' + field.fieldName)">
        <i class="picklist-icon" coreUIIcon="search" scale="1.2"></i>
      </button>
      <div class="text-style-3 field-description">
        <p>{{ field.fieldDescription }}</p>
        <p class="text-style-6 field-type">({{ field.fieldType }})</p>
      </div>
    </li>
  </ul>
  <div coreUIDivider *ngIf="i < chat.attributeTables.length - 1"></div>
</div>
